import { Button, ThemeObservable as onThemeChange } from '@/hub-shared'
import { CSSProperties, useEffect, useState } from 'react'

import './actions-modal.component.scoped.scss'

interface Props {
  onCloseModal: () => void
  onPreviousButtonClick: () => void
}

export default ({ onCloseModal, onPreviousButtonClick }: Props) => {
  const [theme, setTheme] = useState('light')

  useEffect(() => {
    const onChangeThemeSubscription = onThemeChange?.subscribe((theme) => {
      setTheme(theme)
    })

    return () => onChangeThemeSubscription?.unsubscribe()
  }, [])

  const actionButtonModalStyle: CSSProperties = {
    maxHeight: '30px',
    maxWidth: '30px',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }

  return (
    <div className="actions-modal display-flex">
      <Button
        className="rounded button-action"
        size="sm"
        color={`var(--pink-${theme === 'dark' ? '10' : '95'})`}
        borderColor="transparent"
        textColor="var(--primary_color)"
        style={actionButtonModalStyle}
        customPadding="10px"
        onClick={() => onPreviousButtonClick()}
      >
        <i className="fa-solid fa-arrow-left small"></i>
      </Button>
      <Button
        className="rounded button-action"
        size="sm"
        color={`var(--pink-${theme === 'dark' ? '10' : '95'})`}
        borderColor="transparent"
        textColor="var(--primary_color)"
        style={actionButtonModalStyle}
        customPadding="10px"
        onClick={() => onCloseModal()}
      >
        <i className="fa-solid fa-xmark small"></i>
      </Button>
    </div>
  )
}
